import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

export default function NotFound() {
  return (
    <div className="notfound">
      <div className="notfound__inner">
        <div className="notfound__emoji">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            <line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/>
          </svg>
        </div>
        <h1 className="notfound__title">Lost in the Desert?</h1>
        <p className="notfound__sub">This page seems to have wandered off into the Agafay. Don't worry — we'll guide you back.</p>
        <div className="notfound__links">
          <Link to="/" className="btn btn-primary">Back to Home</Link>
          <Link to="/tours" className="btn btn-ghost">Browse Tours</Link>
          <Link to="/contact" className="btn btn-ghost">Contact Us</Link>
        </div>
        <div className="notfound__suggestions">
          <p>Popular pages:</p>
          <div className="notfound__tags">
            <Link to="/tours/atlas-mountains-day-trip">Atlas Mountains</Link>
            <Link to="/activities/hot-air-balloon-marrakech">Hot Air Balloon</Link>
            <Link to="/tours/agafay-desert-day-trip">Agafay Desert</Link>
            <Link to="/activities/marrakech-cooking-class">Cooking Class</Link>
            <Link to="/morocco-guide">Morocco Guide</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
